import { render, staticRenderFns } from "./WorkSection.vue?vue&type=template&id=ef8fd85a&scoped=true"
import script from "./WorkSection.vue?vue&type=script&lang=js"
export * from "./WorkSection.vue?vue&type=script&lang=js"
import style0 from "./WorkSection.vue?vue&type=style&index=0&id=ef8fd85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8fd85a",
  null
  
)

export default component.exports